import { render, staticRenderFns } from "./deposit-list.vue?vue&type=template&id=6d181858&"
import script from "./deposit-list.vue?vue&type=script&lang=js&"
export * from "./deposit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports